import * as React from "react";

export const ExpertChatIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.7062 26.4276C50.2764 10.2291 35.4389 7.15291 28.6784 7.52939C10.6571 8.53296 0.410457 29.2838 10.5902 43.9759C15.9209 51.6696 25.7087 54.3467 34.3479 53.155C42.1772 52.0751 55.2431 43.3408 52.7062 26.4276Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.036 29.8746C20.9703 25.0027 21.2748 20.7397 23.254 17.6948C25.2332 14.6498 28.5826 13.1273 32.0843 13.7363C34.5203 14.0408 36.804 15.5633 38.022 17.6948C40.3057 22.2622 39.24 28.0476 37.2607 32.615C36.4995 33.9853 35.7383 34.8987 34.6725 35.8122C30.1051 39.1617 23.4062 36.878 22.036 29.8746Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.5247 29.5383C20.6968 29.6426 19.3076 29.7781 18.9339 29.2186C18.2544 28.2017 17.8679 23.7402 18.4162 22.6386C18.9666 21.754 20.4358 21.8772 21.4587 21.8829"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M39.2201 30.727C39.9653 30.8972 41.2171 31.1435 41.5764 30.6177C42.2294 29.6618 42.7472 25.2601 42.2926 24.1215C41.8278 23.1983 40.4938 23.2027 39.568 23.1261"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.9622 30.8143C20.2955 34.4574 21.4454 36.4888 23.0823 37.236"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.4111 37.6592C22.6538 37.1906 22.2822 36.8326 21.7311 36.1577"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.5542 23.8317L39.8644 30.1798L41.6124 24.5217"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.8262 22.7902L20.516 29.1383L18.768 23.4802"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.845 37.9437C30.1045 38.2482 28.2776 37.7914 27.0596 36.8779"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M39.0889 30.4832C39.5456 30.1787 40.0024 30.0265 40.1546 29.722C40.3068 29.5697 40.3068 29.5697 40.3068 29.4175"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.2765 29.8746C20.972 29.7224 20.8197 29.5701 20.6675 29.2656"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.4145 32.2051C31.1965 32.8141 29.5218 32.9663 28.4561 32.2051"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.6963 41.1453C23.1249 42.7563 26.2683 44.9531 29.6975 45.0995C32.9837 45.246 36.4129 43.7814 37.4131 41.8775"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.4209 37.1821C27.4209 38.5524 27.2686 39.1613 27.1164 40.6838L24.9293 40.6839C20.9709 41.9018 18.9917 42.9676 17.7737 44.1855C16.5557 45.4035 15.4255 47.203 14.9688 48.2687M44.3878 48.2687C44.0833 46.4418 42.2856 43.8811 39.6974 42.8153C38.6317 42.3586 35.1726 41.4451 33.6501 40.9883L33.3456 39.4659C33.1934 38.2479 33.1934 38.4001 33.1934 37.1822"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.2993 14.9541C28.7287 17.835 31.8726 20.3044 36.7313 20.3044"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <ellipse
      cx="34.2297"
      cy="24.5629"
      rx="2.50116"
      ry="2.50116"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="27.1102"
      cy="24.2115"
      r="2.55846"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.6689 24.7484C30.3354 24.5028 30.7385 24.4998 31.4207 24.7484"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.7383 25.1197C37.9396 25.2616 38.5677 25.2099 39.6641 24.9885"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.1032 24.6434C22.8937 24.6607 22.2743 24.5445 21.2065 24.2113"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M39.292 22.7048C39.4442 26.9678 44.1098 32.0059 45.0233 36.8778C45.48 39.1615 44.4143 41.5975 42.7396 42.9677"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.7309 21.6531C21.2742 24.2413 20.3607 26.8295 19.1427 28.961C17.1635 32.4627 15.032 34.8986 15.641 39.1615C15.7933 40.8363 16.7068 42.3587 17.9247 43.2722"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
